module.exports = __webpack_public_path__ + "img/arh_7.a81d1e86.jpg";